<template>
  <v-sheet
    v-if="comment.body || edit || !isIssueDescription"
    @click="emit('show-buttons')"
  >
    <v-sheet v-if="!edit && showButtons" class="float-end">
      <v-btn
        icon="mdi-close"
        variant="plain"
        @click.stop="emit('hide-buttons')"
      /><v-btn
        v-tooltip:bottom="'Edit the comment'"
        variant="plain"
        @click="startEdit"
        >Edit</v-btn
      ><v-btn
        v-tooltip:bottom="'Go to comment at forgejo'"
        :href="comment.html_url"
        icon="mdi-link"
        variant="plain"
      />
    </v-sheet>
    <v-card-subtitle class="text-start"
      >{{ comment.user?.login }} <reltime :time="comment.created_at"
    /></v-card-subtitle>
    <CommentBody
      :comment="comment.body || ''"
      :edit
      @cancel-edit="endEdit"
      @change="save"
    />
  </v-sheet>
  <div v-else>
    <v-btn @click="startEdit">Add description</v-btn>
  </div>
  <v-row v-if="attachmentsData?.data" class="d-flex">
    <v-col
      v-for="asset in attachmentsData.data"
      :key="asset.id || 0"
      class="align-self-end"
      cols="4"
    >
      <CommentAsset :asset />
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import {
  type Comment,
  useIssueListIssueCommentAttachments,
} from "../gen/forgejo-vue";
import { ref } from "vue";
const props = defineProps<{
  owner: string;
  repo: string;
  isIssueDescription: boolean;
  comment: Comment;
  showButtons: boolean;
}>();
const emit = defineEmits<{
  (e: "change", comment: string): void;
  (e: "show-buttons" | "hide-buttons"): void;
}>();

const { data: attachmentsData } = useIssueListIssueCommentAttachments(
  props.owner,
  props.repo,
  props.comment.id ?? 0,
);

const edit = ref(false);

function startEdit() {
  edit.value = true;
}
function endEdit() {
  edit.value = false;
  emit("hide-buttons");
}

function save(newComment: string) {
  edit.value = false;
  emit("change", newComment);
}
</script>
